import { useEntityId } from '@/lib/offline/operations';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SalidasCamadaSection } from '@/components/SalidasCamadaSection';
import { AppHeaderContent } from '@/components/AppHeaderContent';
import { useContextoSalidas, useSalidasCamada } from '@/lib/queries/salidas';

/** Listado completo de salidas; las acciones siguen viviendo en la sección compartida. */
export function CamadaSalidasPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { camadaId: camadaIdParam } = useParams<{ camadaId: string }>();
  const camadaId = useEntityId(camadaIdParam, 'camadas');
  const detalleQ = useContextoSalidas(camadaId);
  const salidasQ = useSalidasCamada(camadaId);
  const camada = detalleQ.data?.camada;
  const salidas = salidasQ.data ?? [];

  if (detalleQ.isLoading || salidasQ.isLoading) {
    return (
      <main className="container mx-auto max-w-md px-4 py-6">
        <p className="text-text-secondary">{t('common.loading')}</p>
      </main>
    );
  }
  if (detalleQ.isError || salidasQ.isError || !camada) {
    return (
      <main className="container mx-auto max-w-md px-4 py-6">
        <p role="alert" className="text-warning-text">
          {t('common.error')}
        </p>
        <button
          type="button"
          onClick={() => navigate('/camadas')}
          className="mt-3 text-sm text-accent"
        >
          ← {t('camada_detalle.volver')}
        </button>
      </main>
    );
  }

  return (
    <main className="cm-form-page mx-auto max-w-md px-4">
      <header className="ui-global-header" data-testid="app-header">
        <AppHeaderContent backTo={`/camadas?camada=${camada.id}`} backLabel="Camadas" />
      </header>
      <h1 className="ui-page-title">Salidas a matadero</h1>
      <p className="cm-form-context">
        {camada.codigo_lote} ·{' '}
        {t('camada_detalle.salidas_listado_subtitulo', { n: salidas.length })}
        {camada.cerrada ? ' · Finalizada' : ''}
      </p>
      <SalidasCamadaSection
        camadaId={camada.id}
        lotes={detalleQ.data?.lotes ?? []}
        cerrada={camada.cerrada}
        listadoCompleto
        ocultarCabecera
      />
    </main>
  );
}

export default CamadaSalidasPage;
